/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfJobListResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfJobListResponse } from '../models/index.js';
// @ts-ignore
import { DynamicWatermarkRequestBuilderNavigationMetadata, DynamicWatermarkRequestBuilderRequestsMetadata, type DynamicWatermarkRequestBuilder } from './dynamicWatermark/index.js';
// @ts-ignore
import { FilePreviewRequestBuilderRequestsMetadata, type FilePreviewRequestBuilder } from './filePreview/index.js';
// @ts-ignore
import { JobsItemRequestBuilderNavigationMetadata, type JobsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { TranscodeRequestBuilderRequestsMetadata, type TranscodeRequestBuilder } from './transcode/index.js';
// @ts-ignore
import { type WatermarkRequestBuilder, WatermarkRequestBuilderRequestsMetadata } from './watermark/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /jobs
 */
export interface JobsRequestBuilder extends BaseRequestBuilder<JobsRequestBuilder> {
    /**
     * The dynamicWatermark property
     */
    get dynamicWatermark(): DynamicWatermarkRequestBuilder;
    /**
     * The filePreview property
     */
    get filePreview(): FilePreviewRequestBuilder;
    /**
     * The transcode property
     */
    get transcode(): TranscodeRequestBuilder;
    /**
     * The watermark property
     */
    get watermark(): WatermarkRequestBuilder;
    /**
     * Gets an item from the ApiSdk.jobs.item collection
     * @param id Unique identifier of the item
     * @returns {JobsItemRequestBuilder}
     */
     byId(id: Guid) : JobsItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfJobListResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<JobsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfJobListResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<JobsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface JobsRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
    status?: string;
    type?: string;
}
/**
 * Uri template for the request builder.
 */
export const JobsRequestBuilderUriTemplate = "{+baseurl}/jobs{?page*,pageSize*,status*,type*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const JobsRequestBuilderNavigationMetadata: Record<Exclude<keyof JobsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        navigationMetadata: JobsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    dynamicWatermark: {
        requestsMetadata: DynamicWatermarkRequestBuilderRequestsMetadata,
        navigationMetadata: DynamicWatermarkRequestBuilderNavigationMetadata,
    },
    filePreview: {
        requestsMetadata: FilePreviewRequestBuilderRequestsMetadata,
    },
    transcode: {
        requestsMetadata: TranscodeRequestBuilderRequestsMetadata,
    },
    watermark: {
        requestsMetadata: WatermarkRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const JobsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: JobsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfJobListResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
